import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { sendMetaEvent } from "../../helpers/send-event";

export const MetaPixel = ({ sendEvent, ...otherData }) => {

    useEffect(() => {
        if(sendEvent && window) {
            const origin = window.location.origin + window.location.pathname;
            sendMetaEvent('ViewContent', origin, otherData);
        }
    }, [])

    return (
        <Helmet>
            <script>
                {`
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '521509588384359');
                fbq('track', 'PageView');
            `}
            </script>
            <noscript>
                {`
                    <img height="1" width="1" style="display:none"src="https://www.facebook.com/tr?id=521509588384359&ev=PageView&noscript=1"/>
                `}
            </noscript>
        </Helmet>
    );
};

export const TiktokPixel = () => {
    return (
        <Helmet>
            <script id="tiktok-pixel-script">
                {`
                    !function (w, d, t) {
                        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
                      
                        ttq.load('C95VICBC77U63IDI5570');
                        ttq.page();
                      }(window, document, 'ttq');
                ` }
            </script>

            {/* <noscript id="tiktok-pixel-image">
                {`
                    <noscript key="image" id="tiktok-pixel-image">{``}</noscript>
                `}
            </noscript> */}
        </Helmet>
    );
};

export const Klaviyo = () => {
    return (
        <Helmet>
            <script async type="text/javascript" src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=WvPWsx"></script>
        </Helmet>
    );
}

export const HotjarPixel = () => {
    return (
        <Helmet>
            <script id="hotjar-pixel">
                {`
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:1520239,hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                ` }
            </script>
        </Helmet>
    )
}

export const AdsenseVerification = () => {
    return (
        <Helmet>
            <script async id="adsense-verification" src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4198861759837041" crossorigin="anonymous"/>
        </Helmet>
    )
}